import React, { useEffect } from 'react';
import { DocumentsManager, useDocumentsState } from '@atlas/core';

import SeoPageText from 'components/SeoPage/SeoPageText';
import { Loader } from '@atlas/ui';
import UploadForm from './UploadForm';
import UploadDocumentList from './UploadDocumentList';

const Verification = () => {
  const documentsState = useDocumentsState();
  const { documents, documentTypes, loading } = documentsState;

  useEffect(() => {
    DocumentsManager.fetchDocuments();
  }, []);

  if (loading || !documentTypes.length) {
    return <Loader className="profile-loader relative" />;
  }

  return (
    <>
      <UploadForm documentTypes={documentTypes} />
      <UploadDocumentList documents={documents} />
      <SeoPageText />
    </>
  );
};

export default Verification;
